import { TFunction } from 'i18next'

export const getTeamTypeOptions = (t: TFunction): Record<string, { title: string; subtext: string }> => ({
    saas: {
        title: t('modalWindow.enterTeamType.saasTypeTitle'),
        subtext: t('modalWindow.enterTeamType.saasTypeSubtext'),
    },
    enterprise_managed_service: {
        title: t('modalWindow.enterTeamType.enterpriseManagedTypeTitle'),
        subtext: t('modalWindow.enterTeamType.enterpriseSelfServeTypeSubtext'),
    },
    enterprise_self_serve: {
        title: t('modalWindow.enterTeamType.enterpriseSelfServeTypeTitle'),
        subtext: t('modalWindow.enterTeamType.enterpriseSelfServeTypeSubtext'),
    },
    agency_partners: {
        title: t('modalWindow.enterTeamType.agencyPartnerTypeTitle'),
        subtext: t('modalWindow.enterTeamType.agencyPartnerTypeSubtext'),
    },
    internal: {
        title: t('accountType.internal'),
        subtext: '',
    },
    super_admin: {
        title: t('accountType.internalSuperAdmin'),
        subtext: '',
    },
})
